import React from "react"
import {Box} from "@mui/material"
import Spinner from "./Spinner"

function Loading({error}: {error?: string | null}) {
  if (!error) {
    return <Spinner/>
  }

  return (
    <Box
      sx={{
        p: "20px",
        bgcolor: "lightcoral",
        color: "white",
        fontSize: "3rem",
      }}
    >
      {error}
    </Box>
  )
}

export default Loading
